var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import React from "react";
import { i18next } from "./../../wix-rich-content-common";
import viewerVitalTranslations from "../translations/vitalTranslations.json";
import ContentViewer from "./ContentViewer";
const vitalTranslationsWithDefaults = addDefaultsFromEnglish(viewerVitalTranslations);
const TranslatedContentViewer = (props) => {
  const locale = props.locale;
  const [resourcesState, setResourcesState] = React.useState(() => {
    return {
      status: "READY",
      loadedLocales: ["en"],
      i18nextInstance: createI18nextInstance({
        activeLocale: locale,
        resources: vitalTranslationsWithDefaults
      })
    };
  });
  const { i18nextInstance, loadedLocales } = resourcesState;
  if (locale !== i18nextInstance.language) {
    i18nextInstance.changeLanguage(locale);
  }
  React.useEffect(() => {
    if (loadedLocales.includes(locale) || resourcesState.status !== "READY") {
      return;
    }
    setResourcesState((prevState) => __spreadProps(__spreadValues({}, prevState), { status: "LOADING" }));
    import(
      /* webpackChunkName: "ricos_viewer_messages_[request]" */
      `../translations/locale/messages_${locale}.json`
    ).then((response) => response.default).then((localeResource) => {
      i18nextInstance.addResourceBundle(locale, "translation", localeResource, true, true);
      setResourcesState((prevState) => {
        return __spreadProps(__spreadValues({}, prevState), {
          status: "READY",
          loadedLocales: [...prevState.loadedLocales, locale]
        });
      });
    }).catch((err) => {
      console.error(`can't find ${locale} locale`, err);
      setResourcesState((prevState) => {
        return __spreadProps(__spreadValues({}, prevState), { status: "ERROR" });
      });
    });
  }, [locale, loadedLocales]);
  const t = React.useMemo(() => i18nextInstance.t.bind(i18nextInstance), [i18nextInstance]);
  return /* @__PURE__ */ React.createElement(ContentViewer, __spreadProps(__spreadValues({}, props), { t }));
};
function createI18nextInstance({
  activeLocale,
  resources
}) {
  const resourcesWithNs = Object.keys(resources).reduce((acc, key) => {
    acc[key] = { translation: resources[key] };
    return acc;
  }, {});
  const instance = i18next.createInstance({
    lng: activeLocale,
    keySeparator: "$",
    interpolation: { escapeValue: false },
    resources: resourcesWithNs
  });
  instance.init();
  return instance;
}
function addDefaultsFromEnglish(resources) {
  const english = resources.en;
  return Object.keys(resources).reduce((acc, locale) => {
    acc[locale] = __spreadValues(__spreadValues({}, english), resources[locale]);
    return acc;
  }, {});
}
export {
  TranslatedContentViewer
};
//# sourceMappingURL=TranslatedContentViewer.js.map
